// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceLarge__container___1B-ek","rank":"PriceLarge__rank___Ct4Hw"};